import { Card, Grid, Typography } from '@mui/material';
import DashboardStatListCard from './DashboardStatListCard';


function DashboardYKMeetingsCard({ countList }) {

    return (

        <Card
            sx={{
                backgroundColor: '#FFFFFF',
                borderRadius: '8px',
                boxShadow: 2,
                padding: '10px',
                height: '190px'
            }}
        >

            <Typography
                variant='h6'
                sx={{ padding: '5px' }}
            >

                YK Yetkili Olduğunuz Toplantılar
            </Typography>
            <Grid container spacing={1} direction="row">
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"allFinish"} inst={"yk"} />
                </Grid>
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"allOngoing"} inst={"yk"} />
                </Grid>
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"admin"} inst={"yk"} />
                </Grid>
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"review"} inst={"yk"} />
                </Grid>
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"video"} inst={"yk"} />
                </Grid>
                <Grid item xs={6} md={2} lg={2}>
                    <DashboardStatListCard countList={countList} type={"vote"} inst={"yk"} />
                </Grid>
            </Grid>
        </Card>

    );
}

export default DashboardYKMeetingsCard;